/* Al-Haq "Find my size" – see snippets/alhaq-size-finder.liquid */
(function () {
  'use strict';

  var STORE_KEY = 'alhaq-size-profile';
  var TEES = ['XS', 'S', 'M', 'L', 'XL'];
  var LARGE_TEES = ['L', 'XL'];
  var TOO_BIG = ['XL'];
  var KLAVIYO_ID = 'RiGSfL';

  function loadProfile() {
    try { return JSON.parse(localStorage.getItem(STORE_KEY)) || {}; } catch (e) { return {}; }
  }
  function saveProfile(p) {
    try { localStorage.setItem(STORE_KEY, JSON.stringify(p)); } catch (e) { /* private mode */ }
  }

  function fmtHeight(inches) {
    return Math.floor(inches / 12) + 'ft ' + (inches % 12);
  }
  function parseHeight(str) {
    var m = /(\d)\s*ft\s*(\d{1,2})?/.exec(str || '');
    return m ? parseInt(m[1], 10) * 12 + (m[2] ? parseInt(m[2], 10) : 0) : null;
  }
  // "34 (5-6 years)" / "20 (9-12 months)" / "22 (1-1.5 years)" / "46 (11 years)"
  function parseAge(label) {
    var m = /\(([\d.]+)\s*(?:-|–)?\s*([\d.]+)?\s*(year|month)/i.exec(label || '');
    if (!m) return null;
    var a = parseFloat(m[1]);
    var b = m[2] ? parseFloat(m[2]) : a;
    var k = /month/i.test(m[3]) ? 1 / 12 : 1;
    return { min: a * k, max: b * k };
  }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  function Finder(el) {
    this.el = el;
    this.body = el.querySelector('[data-alhaq-sf-body]');
    this.cfg = JSON.parse(el.querySelector('[data-alhaq-sf-config]').textContent);
    var c = this.cfg;
    this.sizeValues = c.options[c.sizePos - 1] || [];
    this.fitValues = c.fitPos ? (c.options[c.fitPos - 1] || []) : [];
    this.kids = this.sizeValues.some(function (v) { return /year|month/i.test(v); });

    // Height bands, only for sizes this product actually comes in
    this.bands = [];
    if (!this.kids && c.heights) {
      var hs = c.heights.split(','), ss = c.heightSizes.split(','), self = this;
      ss.forEach(function (s, i) {
        if (self.sizeValues.indexOf(s) === -1 || !hs[i]) return;
        var parts = hs[i].split('–');
        var lo = parseHeight(parts[0]), hi = parseHeight(parts[1] || parts[0]);
        if (lo && hi) self.bands.push({ size: s, min: lo, max: hi, label: hs[i].trim() });
      });
    }
    this.ages = [];
    if (this.kids) {
      var self2 = this;
      this.sizeValues.forEach(function (v) {
        var r = parseAge(v);
        if (r) self2.ages.push({ size: v, min: r.min, max: r.max });
      });
    }
    this.mode = this.kids ? (this.ages.length ? 'kids' : 'none') : (this.bands.length ? 'adult' : 'none');
    el.setAttribute('data-mode', this.mode);
    this.render();
  }

  Finder.prototype.render = function () {
    if (this.mode === 'adult') return this.renderAdult();
    if (this.mode === 'kids') return this.renderKids();
    this.body.innerHTML = '';
  };

  Finder.prototype.renderAdult = function () {
    var p = loadProfile(), self = this;
    var h = p.h || null;
    var ft = h ? Math.floor(h / 12) : '', inch = h ? h % 12 : '';
    var askFit = this.fitValues.length > 1;
    var maxH = this.bands[this.bands.length - 1].max;
    if (h && h > maxH) { h = maxH; ft = Math.floor(h / 12); inch = h % 12; }
    var ftOpts = '<option value="">ft</option>' + [4, 5, 6, 7].filter(function (n) { return n * 12 <= maxH; }).map(function (n) {
      return '<option value="' + n + '"' + (n === ft ? ' selected' : '') + '>' + n + ' ft</option>';
    }).join('');
    var inOpts = '<option value="">in</option>' + Array.apply(null, Array(12)).map(function (_, n) {
      return '<option value="' + n + '"' + (n === inch ? ' selected' : '') + '>' + n + ' in</option>';
    }).join('');
    var tees = TEES.map(function (t) {
      return '<button type="button" class="alhaq-sf__chip' + (p.t === t ? ' is-on' : '') + '" data-tee="' + t + '" aria-pressed="' + (p.t === t) + '">' + t + '</button>';
    }).join('');

    this.body.innerHTML =
      '<div class="alhaq-sf__step">' +
        '<p class="alhaq-sf__q"><span class="alhaq-sf__n">1</span>How tall are you?</p>' +
        '<div class="alhaq-sf__height" data-units="ft">' +
          '<div class="alhaq-sf__ft"><select aria-label="Feet" data-ft>' + ftOpts + '</select><select aria-label="Inches" data-in>' + inOpts + '</select></div>' +
          '<div class="alhaq-sf__cm"><input type="number" inputmode="numeric" min="140" max="' + Math.round(maxH * 2.54) + '" placeholder="e.g. 178" aria-label="Height in cm" data-cm' + (h ? ' value="' + Math.round(h * 2.54) + '"' : '') + '><span>cm</span></div>' +
          '<button type="button" class="alhaq-sf__units" data-units-toggle>Use cm</button>' +
        '</div>' +
      '</div>' +
      (askFit ?
      '<div class="alhaq-sf__step">' +
        '<p class="alhaq-sf__q"><span class="alhaq-sf__n">2</span>What T-shirt size do you usually wear?</p>' +
        '<div class="alhaq-sf__chips" role="group" aria-label="Usual T-shirt size">' + tees + '</div>' +
        '<p class="alhaq-sf__hint">This picks the fit: XS, S or M → Regular. L → Large.</p>' +
      '</div>' : '') +
      '<div class="alhaq-sf__result" data-result aria-live="polite"></div>';

    var heightBox = this.body.querySelector('.alhaq-sf__height');
    this.body.querySelector('[data-units-toggle]').addEventListener('click', function () {
      var cm = heightBox.getAttribute('data-units') === 'ft';
      heightBox.setAttribute('data-units', cm ? 'cm' : 'ft');
      this.textContent = cm ? 'Use feet & inches' : 'Use cm';
      self.update();
    });
    // Inches stop at the tallest height for this style (e.g. 6ft 5 / 6ft 4)
    var ftSel = this.body.querySelector('[data-ft]'), inSel = this.body.querySelector('[data-in]');
    function capInches() {
      var top = parseInt(ftSel.value, 10) === Math.floor(maxH / 12) ? maxH % 12 : 11;
      Array.prototype.forEach.call(inSel.options, function (o) { if (o.value !== '') o.hidden = o.disabled = parseInt(o.value, 10) > top; });
      if (inSel.value !== '' && parseInt(inSel.value, 10) > top) inSel.value = String(top);
    }
    ftSel.addEventListener('change', capInches);
    capInches();
    this.body.querySelectorAll('select, input').forEach(function (i) {
      i.addEventListener('input', function () { self.update(); });
      i.addEventListener('change', function () { self.update(); });
    });
    this.body.querySelectorAll('[data-tee]').forEach(function (b) {
      b.addEventListener('click', function () {
        self.body.querySelectorAll('[data-tee]').forEach(function (x) { x.classList.remove('is-on'); x.setAttribute('aria-pressed', 'false'); });
        b.classList.add('is-on'); b.setAttribute('aria-pressed', 'true');
        self.update();
      });
    });
    this.update();
  };

  Finder.prototype.readHeight = function () {
    var box = this.body.querySelector('.alhaq-sf__height');
    if (box.getAttribute('data-units') === 'cm') {
      var cm = parseFloat(this.body.querySelector('[data-cm]').value);
      if (!(cm >= 120 && cm <= 230)) return null;
      return Math.min(Math.round(cm / 2.54), this.bands[this.bands.length - 1].max);
    }
    var ft = this.body.querySelector('[data-ft]').value, inch = this.body.querySelector('[data-in]').value;
    if (ft === '') return null;
    return parseInt(ft, 10) * 12 + (inch === '' ? 0 : parseInt(inch, 10));
  };

  Finder.prototype.bandFor = function (h) {
    var b = this.bands, hits = b.filter(function (x) { return h >= x.min && h <= x.max; });
    if (hits.length) return { size: hits[0].size, alt: hits[1] ? hits[1].size : null, note: '' };
    if (h < b[0].min) return { size: b[0].size, alt: null, note: 'below' };
    if (h > b[b.length - 1].max) return { size: b[b.length - 1].size, alt: null, note: 'above' };
    // In a gap between two bands: take the longer one
    for (var i = 0; i < b.length; i++) if (b[i].min > h) return { size: b[i].size, alt: null, note: '' };
    return { size: b[b.length - 1].size, alt: null, note: '' };
  };

  Finder.prototype.update = function () {
    var out = this.body.querySelector('[data-result]');
    var h = this.readHeight();
    var teeBtn = this.body.querySelector('[data-tee].is-on');
    var tee = teeBtn ? teeBtn.getAttribute('data-tee') : null;
    var askFit = this.fitValues.length > 1;
    var p = loadProfile();
    if (h) p.h = h;
    if (tee) p.t = tee;
    saveProfile(p);

    if (!h) { out.innerHTML = ''; return; }
    if (askFit && !tee) { out.innerHTML = '<p class="alhaq-sf__wait">Now pick your usual T-shirt size.</p>'; return; }

    // Fitted thobes (Regular / Large) are cut for up to a T-shirt size L
    if (tee && TOO_BIG.indexOf(tee) > -1 && this.fitValues.length) {
      out.innerHTML =
        '<p class="alhaq-sf__rec-label">Not quite the right cut</p>' +
        '<p class="alhaq-sf__rec">Our thobes go up to a T-shirt size L</p>' +
        '<p class="alhaq-sf__why">Even our Large fit is likely to feel tight across the chest if you usually wear ' + tee + '. Our Moroccan styles have a looser, relaxed cut:</p>' +
        '<p class="alhaq-sf__links"><a href="/collections/moroccan-collection">Moroccan Gandouras</a><a href="/collections/royal-hooded-djellabas">Royal Djellabas</a><a href="/collections/winter-hooded-moroccan-thobes">Winter Hooded Djellabas</a></p>' +
        '<p class="alhaq-sf__note">Not sure? Message us on Instagram <a href="https://instagram.com/alhaqthobes" target="_blank" rel="noopener">@alhaqthobes</a> and we’ll help.</p>';
      return;
    }

    var r = this.bandFor(h);
    var fit = null, fitNote = '';
    if (this.fitValues.length) {
      var want = tee && LARGE_TEES.indexOf(tee) > -1 ? 'Large' : 'Regular';
      fit = this.fitValues.indexOf(want) > -1 ? want : this.fitValues[0];
      if (fit !== want) fitNote = 'This colour only comes in ' + esc(fit) + ' fit.';
    }
    if (this.fitValues.length === 1) fitNote = 'This colour comes in ' + esc(this.fitValues[0]) + ' fit only.';
    var why = 'Based on ' + fmtHeight(h) + (tee ? ' and a usual T-shirt size ' + tee : '') + '.';
    var extra = '';
    if (r.alt) extra = 'You’re between ' + r.size + ' and ' + r.alt + '. Choose ' + r.alt + ' if you like it to sit lower on the ankle.';
    if (r.note === 'below') extra = 'You’re shorter than our smallest size is cut for, so ' + r.size + ' may be a little long. Message us and we’ll help.';
    if (r.note === 'above') extra = 'You’re taller than our longest size is cut for, so ' + r.size + ' may sit above the ankle. Message us and we’ll help.';
    this.showResult(out, r.size, fit, why, [extra, fitNote]);
  };

  Finder.prototype.renderKids = function () {
    var p = loadProfile(), self = this;
    var months = this.ages.some(function (a) { return a.min < 1; });
    var lo = Math.floor(this.ages[0].min), hi = Math.ceil(this.ages[this.ages.length - 1].max);
    var opts = [];
    if (months) {
      [[0.5, '6 months'], [0.75, '9 months'], [1, '1 year'], [1.5, '18 months'], [2, '2 years'], [2.5, '2½ years'], [3, '3 years'], [3.5, '3½ years'], [4, '4 years']]
        .forEach(function (o) { if (o[0] <= hi) opts.push(o); });
    } else {
      for (var y = Math.max(lo, 3); y <= hi; y++) opts.push([y, y + ' years']);
    }
    var sel = '<option value="">Choose age</option>' + opts.map(function (o) {
      return '<option value="' + o[0] + '"' + (p.k === o[0] ? ' selected' : '') + '>' + o[1] + '</option>';
    }).join('');
    this.body.innerHTML =
      '<div class="alhaq-sf__step">' +
        '<p class="alhaq-sf__q"><span class="alhaq-sf__n">1</span>How old is your child?</p>' +
        '<div class="alhaq-sf__height"><div class="alhaq-sf__ft"><select aria-label="Age" data-age>' + sel + '</select></div></div>' +
      '</div>' +
      '<div class="alhaq-sf__step">' +
        '<label class="alhaq-sf__check"><input type="checkbox" data-tall' + (p.tall ? ' checked' : '') + '> Tall for their age</label>' +
      '</div>' +
      '<div class="alhaq-sf__result" data-result aria-live="polite"></div>';
    this.body.querySelectorAll('select, input').forEach(function (i) {
      i.addEventListener('change', function () { self.updateKids(); });
    });
    this.updateKids();
  };

  Finder.prototype.updateKids = function () {
    var out = this.body.querySelector('[data-result]');
    var v = this.body.querySelector('[data-age]').value;
    var tall = this.body.querySelector('[data-tall]').checked;
    var p = loadProfile();
    p.k = v === '' ? null : parseFloat(v); p.tall = tall; saveProfile(p);
    if (v === '') { out.innerHTML = ''; return; }
    var age = parseFloat(v), a = this.ages, idx = -1, i;
    // Largest size whose age range includes the child's age (room to grow)
    for (i = 0; i < a.length; i++) if (age >= a[i].min && age <= a[i].max) idx = i;
    if (idx === -1) { for (i = 0; i < a.length; i++) if (a[i].min > age) { idx = i; break; } }
    if (idx === -1) idx = a.length - 1;
    var extra = '';
    if (tall && idx < a.length - 1) { idx += 1; extra = 'Sized up one because they’re tall for their age.'; }
    var label = a[idx].size;
    var ageSel = this.body.querySelector('[data-age]');
    this.showResult(out, label, null, 'Based on age ' + ageSel.options[ageSel.selectedIndex].text + '.', [extra]);
  };

  Finder.prototype.variantFor = function (size, fit) {
    var c = this.cfg;
    return c.variants.filter(function (v) {
      return v.o[c.sizePos - 1] === size && (!fit || !c.fitPos || v.o[c.fitPos - 1] === fit);
    })[0];
  };

  Finder.prototype.showResult = function (out, size, fit, why, notes) {
    var self = this;
    var v = this.variantFor(size, fit);
    var name = esc(size) + (fit ? ' · ' + esc(fit) : '');
    var sold = v && !v.a;
    out.innerHTML =
      '<p class="alhaq-sf__rec-label">We recommend</p>' +
      '<p class="alhaq-sf__rec">' + (/\(/.test(size) ? esc(size) : 'Size ' + name) + '</p>' +
      '<p class="alhaq-sf__why">' + why + '</p>' +
      notes.filter(Boolean).map(function (n) { return '<p class="alhaq-sf__note">' + n + '</p>'; }).join('') +
      (sold ? this.soldOutHtml(name) :
      '<button type="button" class="button alhaq-sf__select"' + (!v ? ' disabled' : '') + '>Select ' + name + '</button>');
    if (sold) {
      this.wireNotify(out, v.id);
      this.findSimilar(out.querySelector('[data-similar]'), size, fit);
      return;
    }
    out.querySelector('.alhaq-sf__select').addEventListener('click', function () {
      self.apply(size, fit);
    });
  };

  Finder.prototype.soldOutHtml = function (name) {
    return '<p class="alhaq-sf__note alhaq-sf__note--sold">' + name + ' is sold out in this colour.</p>' +
      '<div class="alhaq-sf__similar" data-similar hidden></div>' +
      '<form class="alhaq-sf__notify" data-notify novalidate>' +
        '<label class="alhaq-sf__notify-label">Email me when it’s back in stock</label>' +
        '<div class="alhaq-sf__notify-row"><input type="email" required autocomplete="email" placeholder="Your email" aria-label="Your email">' +
        '<button type="submit" class="button">Notify me</button></div>' +
        '<p class="alhaq-sf__notify-msg" aria-live="polite"></p>' +
      '</form>';
  };

  // Back-in-stock alert via Klaviyo (needs a "Back in Stock" flow set up in Klaviyo to send the email)
  Finder.prototype.wireNotify = function (out, variantId) {
    var form = out.querySelector('[data-notify]');
    var input = form.querySelector('input'), btn = form.querySelector('button'), msg = form.querySelector('.alhaq-sf__notify-msg');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = input.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { msg.textContent = 'Please enter a valid email address.'; input.focus(); return; }
      btn.disabled = true; msg.textContent = 'Sending…';
      fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + KLAVIYO_ID, {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15' },
        body: JSON.stringify({ data: { type: 'back-in-stock-subscription',
          attributes: { channels: ['EMAIL'], profile: { data: { type: 'profile', attributes: { email: email } } } },
          relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } } } } })
      }).then(function (r) {
        if (!r.ok) throw new Error(r.status);
        form.innerHTML = '<p class="alhaq-sf__notify-done">Thanks – we’ll email ' + esc(email) + ' as soon as it’s back.</p>';
      }).catch(function () {
        btn.disabled = false;
        msg.innerHTML = 'Sorry, that didn’t work. Please message us on Instagram <a href="https://instagram.com/alhaqthobes" target="_blank" rel="noopener">@alhaqthobes</a>.';
      });
    });
  };

  // Other colours of the same style that have this size (and fit) in stock
  Finder.prototype.findSimilar = function (box, size, fit) {
    var scope = this.el.closest('.product-information--inner') || document;
    var links = Array.prototype.filter.call(scope.querySelectorAll('.variations--siblings a[href*="/products/"]'), function (a) {
      return !/\bactive\b/.test(a.parentElement.className);
    }).slice(0, 24);
    if (!links.length) return;
    var found = [];
    Promise.all(links.map(function (a) {
      var path = a.getAttribute('href').split('?')[0].replace(/^https?:\/\/[^/]+/, '');
      return fetch(path + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
        if (!p || !p.options) return;
        var names = p.options.map(function (o) { return String(o.name || o).trim().toLowerCase(); });
        var si = names.indexOf('size'), fi = names.indexOf('fit'); if (fi < 0) fi = names.indexOf('chest');
        if (si < 0) return;
        var v = p.variants.filter(function (x) {
          return x.available && x.options[si] === size && (!fit || fi < 0 || x.options[fi] === fit);
        })[0];
        if (v) found.push({ name: a.title || a.getAttribute('aria-label') || p.title, url: path + '?variant=' + v.id, swatch: (getComputedStyle(a.parentElement).getPropertyValue('--option-color') || '').trim(), order: links.indexOf(a) });
      }).catch(function () {});
    })).then(function () {
      if (!found.length) return;
      found.sort(function (x, y) { return x.order - y.order; });
      box.innerHTML = '<p class="alhaq-sf__similar-label">Available in your size in:</p><div class="alhaq-sf__similar-list">' +
        found.slice(0, 6).map(function (f) {
          return '<a class="alhaq-sf__similar-item" href="' + esc(f.url) + '"><span class="alhaq-sf__similar-dot"' + (f.swatch ? ' style="background:' + esc(f.swatch) + '"' : '') + '></span><span>' + esc(f.name) + '</span></a>';
        }).join('') + '</div>';
      box.hidden = false;
    });
  };

  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  Finder.prototype.pick = function (pos, value) {
    var scope = this.el.closest('.product-information--inner') || document;
    var fs = scope.querySelector('variant-selects [data-index="option' + pos + '"]');
    if (!fs) return false;
    var radio = Array.prototype.filter.call(fs.querySelectorAll('input[type="radio"]'), function (i) { return i.value === value; })[0];
    if (radio) { if (!radio.checked) radio.click(); return true; }
    var sel = fs.querySelector('select');
    if (sel && sel.value !== value) { sel.value = value; sel.dispatchEvent(new Event('change', { bubbles: true })); }
    return !!sel;
  };

  Finder.prototype.apply = async function (size, fit) {
    this.pick(this.cfg.sizePos, size);
    if (fit && this.cfg.fitPos) { await wait(450); this.pick(this.cfg.fitPos, fit); }
    var modal = this.el.closest('modal-dialog');
    if (modal) {
      if (typeof modal.hide === 'function') modal.hide();
      else { var x = modal.querySelector('.product-popup-modal__toggle'); if (x) x.click(); }
    }
  };

  // Tabs in the size guide pop-up
  function initTabs(root) {
    var tabs = root.querySelectorAll('[data-sg-tab]');
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        var id = t.getAttribute('data-sg-tab');
        tabs.forEach(function (x) { x.setAttribute('aria-selected', String(x === t)); });
        root.querySelectorAll('[data-sg-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-sg-panel') !== id; });
      });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-alhaq-sg]:not([data-tabs])').forEach(function (g) {
      g.setAttribute('data-tabs', '');
      initTabs(g);
    });
    (scope || document).querySelectorAll('[data-alhaq-sf]:not([data-ready])').forEach(function (el) {
      el.setAttribute('data-ready', '');
      var f = new Finder(el);
      var guide = el.closest('[data-alhaq-sg]');
      // Styles without a measurement chart (abayas, Bahraini): show size by height
      var chart = guide && guide.querySelector('[data-sg-panel="chart"]');
      if (chart && f.mode === 'adult' && !chart.querySelector('table')) {
        var rows = f.bands.map(function (b) { return '<tr><th scope="row">' + esc(b.size) + '</th><td>' + esc(b.label) + '</td></tr>'; }).join('');
        chart.insertAdjacentHTML('afterbegin',
          '<div class="alhaq-size-chart"><div class="alhaq-size-chart__scroll"><table><thead><tr><th scope="col">Size</th><th scope="col">Your height</th></tr></thead><tbody>' + rows + '</tbody></table></div></div>');
      }
      if (guide && f.mode === 'none') {
        // No calculator for this item: hide the tab and open on the size chart
        var t = guide.querySelector('[data-sg-tab="find"]');
        if (t) t.hidden = true;
        var c = guide.querySelector('[data-sg-tab="chart"]');
        if (c) c.click();
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  // Variant changes re-render the product info; pick up any new pop-up
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; init(); });
  }).observe(document.body, { childList: true, subtree: true });
})();
